import React from 'react';
import { Helmet } from 'react-helmet';

import HeroAbout from '../../components/HeroAbout/HeroAbout';

const AboutPage = () => {
  return (
    <div>
      <Helmet>
        <title>Admin | Glide</title>
        <meta name="description" content="Learn more about us." />
        {/* Other meta tags */}
      </Helmet>
      {/* Your about page content */}
      <HeroAbout />
    </div>
  );
};

export default AboutPage;
